// extracted by mini-css-extract-plugin
export default {"input":"Input_input__HXUUA","label":"Input_label__rM8+O","inputContainer":"Input_inputContainer__UjBlh","textArea":"Input_textArea__-C2oO"};